/** @jsx jsx */
// eslint-disable-next-line
import React from 'react'
import { css, jsx } from '@emotion/core'
import { boxShadow, palette } from '../constants'
import propTypes from 'prop-types'
import { changeDate, toggleModal } from '../actions/calendar'

const styles = {
  container: css`
    display: flex;
    align-items: center;
    background: ${palette.red};
    padding: 0 12px;
    box-shadow: ${boxShadow};
    position: relative;
    z-index: 1;
  `,
  label: css`
    color: ${palette.white};
    margin-right: 15px;
    font-size: 17px;
    font-weight: 700;
    text-transform: uppercase;
  `,
  plusButton: css`
    background: ${palette.white};
    padding: 3px 13px 5px 13px;
    border-radius: 3px;
    border: 0;
    box-shadow: ${boxShadow};
    color: ${palette.black};
    text-decoration: none;
    font-size: 18px;
    cursor: pointer;
    margin-right: 50px;
  `,
  input: css`
    padding: 5px;
    border: 0;
    border-radius: 3px;
    box-shadow: ${boxShadow};
  `,
  link: css`
    color: ${palette.black};
    text-decoration: none;
    font-size: 14px;
    cursor: pointer;
    margin-left: auto;

    button {
      background: ${palette.white};
      padding: 3px 13px 5px 13px;
      border-radius: 3px;
      border: 0;
      box-shadow: ${boxShadow};
    }
  `,
}

// This component is going to control the dates for the calendar
function Header({ height, date }) {
  return (
    <div
      css={css`
        ${styles.container};
        height: ${height}px;
      `}
    >
      <span css={styles.label}>Navigate to date</span>
      <input
        css={styles.input}
        type="month"
        value={date}
        onChange={e => changeDate(e.target.value)} // yyy-mm string date
        onKeyDown={e => e.preventDefault()}
        className="hover"
      />
      <span
        css={css`
          ${styles.label};
          margin-left: 30px;
        `}
      >
        New
      </span>
      <button css={styles.plusButton} className="hover" onClick={() => toggleModal(true)}>
        +
      </button>
      <a href="https://jonidelv.me/" target="_blank" rel="noopener noreferrer" css={styles.link}>
        <button css={styles.link} className="hover">
          Jonatan 👨🏻‍💻
        </button>
      </a>
    </div>
  )
}

Header.propTypes = {
  height: propTypes.number.isRequired,
  date: propTypes.string.isRequired,
}

export default Header
